<template>
  <AuthLayout :pitch="false">
    <div class="checked">
      <h1>Cet email est déjà vérifié.</h1>
      <p>Votre adresse est bien confirmée : vous pouvez vous connecter.</p>
      <div class="actions">
        <router-link to="/login" class="pub-btn pub-btn--primary">Connexion</router-link>
      </div>
    </div>
  </AuthLayout>
</template>

<script>
    import AuthLayout from "@/components/public/AuthLayout.vue";

    export default {
        name: 'MailAlreadyCheckView',
        components: {AuthLayout},
    }
</script>

<style lang="stylus" scoped>
@require '~/src/common/style/public.styl';

.checked
  h1
    margin 0
    color PUB_INK
    font-family PUB_FONT_DISPLAY
    font-weight 400
    font-size 1.9rem !important
    line-height 1.15
    text-align left
  p
    margin 12px 0 0
    color PUB_INK_SOFT
    font-family PUB_FONT_TEXT
    line-height 1.55
  .actions
    display flex
    flex-direction column
    gap 12px
    margin-top 24px
</style>
